import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import i18n from './i18n/i18n.js'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/css/base.css'
import './assets/css/base.scss'


Vue.config.productionTip = true

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

new Vue({
  router,
  i18n,
  render: function (h) {
    return h(App)
  }
}).$mount('#app')
